export const checkReponse = (res) => {
  return res.ok
    ? res.json()
    : res.json()
      .then((err) => Promise.reject(`Error (checkResponse)', ${err}`));
};
